import CalendarRollUpViewState from '../../store/schema/CalendarRollUpViewState';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import datapoints from '../../datapoints';

export default createLegacyActionWithDatapoint(
    'toggleIsCalendarRollUpExpanded',
    datapoints.ToggleIsCalendarRollUpExpanded
)(function toggleIsCalendarRollUpExpanded(viewState: CalendarRollUpViewState) {
    viewState.isExpanded = !viewState.isExpanded;
});
